import React, { useState } from 'react'
import Menu from '@mui/material/Menu'
import { trans } from '@/_providers/Translation'
import { isEditable, isSent, isSigned, isTerminated } from './config'

//images
import menuIcon from '@/assets/img/icons/table-menu.png'
import previewIcon from '@/assets/img/icons/preview.svg'
import mailIcon from '@/assets/img/invoices/icons/send.svg'
import editIcon from '@/assets/img/icons/edit.svg'
import deleteIcon from '@/assets/img/icons/delete.svg'
import terminateIcon from '@/assets/img/icons/cross.svg'

function Options(props) {

    const [table, setTable] = useState({
        options: null
    })

    const contract = props.data || {}

    // A sent contract must stay exactly as it was sent - no editing, no
    // deleting. Terminating it is the only way to close it off.
    const allowEdit = isEditable(contract)
    const allowTerminate = (isSent(contract) || isSigned(contract)) && !isTerminated(contract)

    const handleTableMenu = e => {
        setTable(table => ({
            ...table,
            options: e.currentTarget
        }))
    }

    const handleCloseMenu = () => {
        setTable(table => ({
            ...table,
            options: null
        }))
    }

    const handleOption = fn => {
        handleCloseMenu()

        if (typeof fn === 'function') {
            fn(props.id)
        }
    }

    return (
        <>
            <img src={menuIcon} alt="menu" className="menu" onClick={handleTableMenu} />
            <Menu
                id={'menu-' + props.id}
                anchorEl={table.options}
                keepMounted
                open={Boolean(table.options)}
                onClose={handleCloseMenu}
            >
                <div className="menu-option" onClick={() => handleOption(props.handleView)}>
                    <img src={previewIcon} alt="preview" />
                    {trans('buttons.viewPdf')}
                </div>

                <div className="menu-option" onClick={() => handleOption(props.handleSend)}>
                    <img src={mailIcon} alt="send" />
                    {trans('buttons.sendEmail')}
                </div>

                {/* {allowTerminate &&
                    <div className="menu-option" onClick={() => handleOption(props.handleTerminate)}>
                        <img src={terminateIcon} alt="terminate" />
                        {trans('buttons.terminate')}
                    </div>
                } */}

                {allowEdit &&
                    <div className="menu-option" onClick={() => handleOption(props.handleEdit)}>
                        <img src={editIcon} alt="edit" />
                        {trans('buttons.edit')}
                    </div>
                }

                {allowEdit &&
                    <div
                        className="menu-option"
                        onClick={() => handleOption(props.handleDelete)}
                        style={{
                            color: "#EC5252"
                        }}
                    >
                        <img src={deleteIcon} alt="delete" />
                        {trans('buttons.delete')}
                    </div>
                }
            </Menu>
        </>
    )
}

export default Options
